import posthog from "posthog-js";
import type { Attendee } from "./lib/attendees";

const key = import.meta.env.VITE_POSTHOG_PROJECT_TOKEN;
const host = import.meta.env.VITE_POSTHOG_HOST ?? "https://us.i.posthog.com";

if (key) {
	posthog.init(key, {
		api_host: host,
		defaults: "2026-01-30",
		person_profiles: "identified_only",
	});
	posthog.register({ app: "pickle-event" });
}

/** `guestId` is engine `subscribers.id` — same id BookTime uses after a booking. */
export function identifyPickleAttendee(attendee: Attendee) {
	if (!key || !attendee.guestId.trim()) return;

	const properties: Record<string, string> = {};
	if (attendee.email) properties.email = attendee.email;
	if (attendee.fullName) properties.name = attendee.fullName;

	posthog.identify(attendee.guestId, properties);
}

export function captureAttendeeSignedIn() {
	if (!key) return;
	posthog.capture("attendee_signed_in");
}

export function resetPostHogUser() {
	if (!key) return;
	posthog.reset();
}

export { posthog };
